import React from 'react';
import Alert from '@mui/material/Alert';
import Link from '@mui/material/Link';
import { Link as RouterLink } from 'react-router-dom';

/**
 * Displays an informational alert prompting the user to verify their email.
 *
 * @param {string} message - Message displayed after the "Verify your email" link.
 * @param {object} [sx] - MUI style overrides for the Alert component.
 */
function VerifyEmailPromptAlert({ message, sx }) {
  return (
    <Alert severity="info" sx={sx}>
      <Link
        component={RouterLink}
        to="/settings"
        underline="hover"
        color="primary"
        fontWeight="bold"
      >
        Verify your email
      </Link>{' '}
      {message}
    </Alert>
  );
}

export default VerifyEmailPromptAlert;
